import axios from "axios";

const apiUrl = process.env.BACKEND_ENDPOINT || "";

export async function getBanner(): Promise<any> {
  const response = await axios.post(`${apiUrl}/v1/banner/show`);

  return response?.data;
}